import { isUtenteSpeciale } from "../../modificaProdotti/permessiProdotto";
import useApriProdottoSolaLettura from "../../modificaProdotti/useApriProdottoSolaLettura";
import React from "react";
import apiUrl from "../../Apiurl";
import prodVuoto from "../../prodottoVuoto";

function CodiceVSVoceCliccabile(props) {
  const codiceVS = props.codiceVS;
  const setProductFunction = props.setProductFunction;
  const codiceVSprodCorr = props.codiceVSprodCorr;
  const utente = props.utente;
  const { apriProdotto, errore } = useApriProdottoSolaLettura();
  const inGrassetto = props.inGrassetto;
  const mostraIconaApertura = props.mostraIconaApertura;

  function nonSonCapaceEquindiFaccioIlGiro() {
    const codVS = codiceVS;
    console.log(codVS);

    if (isUtenteSpeciale(utente)) {
      apriProdotto(codVS, (data) => setProductFunction(data[0]));
    } else if (utente.permessiAPI["update:database"]) {
      fetch(apiUrl + "/prodotti/prodotto/showByCodVS/" + codVS)
        .then((resp) => resp.json())
        .then((data) => setProductFunction(data[0] || prodVuoto));
    }
  }

  return (
    <>
    <span
      className="pointer inline-flex items-center"
      onClick={nonSonCapaceEquindiFaccioIlGiro}
    >
      {inGrassetto && (
        <strong className="codiceVScliccabile">{codiceVS}</strong>
      )}
      {!inGrassetto && codiceVSprodCorr !== codiceVS && codiceVS}
      {!inGrassetto && codiceVSprodCorr === codiceVS && (
        <strong className="codiceVScliccabile">{codiceVS}</strong>
      )}
      {mostraIconaApertura && (
        <span className="material-symbols-outlined ml1" aria-hidden="true">
          open_in_new
        </span>
      )}
    </span>
    {errore && <span role="alert">{errore}</span>}
    </>
  );
}

export default CodiceVSVoceCliccabile;
